import type { ChangeEvent } from "react";
import type { UseControllerProps } from "react-hook-form";

import { useController, useFormContext, useWatch } from "react-hook-form";
import { TextActionOptional } from "src/features/observations/components/TextActionOptional";

interface DropDownQuestionProps extends UseControllerProps<ObservationFormState> {
	questionNumber: number;

	answers: ObservationAnswer[];

	staticInput?: boolean;

	showAction?: boolean;
}

const DropDownQuestion = ({
	name,
	rules,
	questionNumber,
	answers,
	staticInput,
	showAction
}: DropDownQuestionProps) => {
	const { control } = useFormContext<ObservationFormState>();

	const {
		field: { onChange, ...field }
	} = useController({
		control,
		name,
		rules
	});

	const { isDisabled } = useWatch({
		control
	});

	const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
		if (staticInput) return;

		onChange(event);
	};

	return (
		<div>
			<select
				id={`question-${questionNumber}`}
				className="w-full md:w-1/2 mt-4 px-3 py-2 bg-white border border-border rounded-lg shadow-xs text-base focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-50 disabled:cursor-not-allowed"
				disabled={isDisabled}
				role="combobox"
				{...field}
				value={(field.value as string | undefined) ?? ""}
				onChange={handleChange}
			>
				<option disabled value="">
					Please select your answer
				</option>

				{answers.map(({ name, uuid }) => (
					<option value={name} key={uuid}>
						{name}
					</option>
				))}
			</select>

			{showAction && (
				<TextActionOptional
					name={`questions.${questionNumber - 1}.action`}
					questionNumber={questionNumber}
					staticInput={staticInput}
				/>
			)}
		</div>
	);
};

export { DropDownQuestion, type DropDownQuestionProps };
